import { Injectable } from '@angular/core';
import {Observable, of} from "rxjs";
import {emptyFillRateComment, emptyPriceIndexDynamicReport, emptyPriceIndexReport, IFillRateComment, IFillRateData, IPositionedMarginReport, IPriceIndexDynamicReport, IPriceIndexReport, IPriceIndexReportLine} from "@retail-data-factory/rdf-angular-types-api";
import {DataService} from "../../../../services/external-api/data.service";
import {map} from "rxjs/operators";
import * as moment from "moment";
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";

@Injectable({
  providedIn: 'root'
})
export class ApiVendorsService {

  constructor(
    private dataService: DataService,
    private configurationManager: ConfigurationManager
  ) { }

  getFillRateComments(orderId: string, itemId: string): Observable<Array<IFillRateComment>> {
    const param = {
      'order_id': orderId,
      'item_code': itemId
    };
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiVendorsUrl')}/fillrate/comments`,param).pipe(
      map(result=>{
        const comments: Array<IFillRateComment> = result.report.map(item=>this.mapFillRateCommentFromService(item));
        return comments;
      })
    );
  }

  mapFillRateCommentFromService(item: object):IFillRateComment {
    const comment:IFillRateComment =  {
      ...emptyFillRateComment,
      orderId: item['order_id'],
      itemId: item['item_code'],
      commentDate: moment(item['comment_date'],'YYYYMMDD').toDate(),
      supplierPartyId: item['user_id'],
      supplierLogin: item['login'],
      side: item['comment_side']?item['comment_side']:'unknown'

      // supplierComment: item['supplier_comment']?item['supplier_comment']:'',
      // supplierReasonCode: item['supplier_reason_code']?item['supplier_reason_code']:'0',
      // supplierReasonDescription: item['supplier_reason_description']?item['supplier_reason_description']:'',
      //
      // retailerComment: item['retailer_comment']?item['retailer_comment']:'',
      // retailerReasonCode: item['retailer_reason_code']?item['retailer_reason_code']:'0',
      // retailerReasonDescription: item['retailer_reason_description']?item['retailer_reason_description']:''
    };
    switch (comment.side) {
      case "retailer":
        comment.supplierComment = item['comment']?item['comment']:'';
        comment.supplierReasonCode = item['reason_code']?item['reason_code']:'';
        comment.supplierReasonDescription = item['reason_description']?item['reason_description']:'';
        break;
      case "supplier":
        comment.retailerComment = item['comment']?item['comment']:'';
        comment.retailerReasonCode = item['reason_code']?item['reason_code']:'';
        comment.retailerReasonDescription = item['reason_description']?item['reason_description']:'';
        break;

    }
    return comment;

  }

  getPositionedMarginReport():Observable<Array<IPositionedMarginReport>> {
    return of([]);
  }

  getPriceIndexReport():Observable<IPriceIndexReport> {
    return of({...emptyPriceIndexReport});
  }
  getPriceIndexDynamicReport():Observable<IPriceIndexDynamicReport> {
    return of({...emptyPriceIndexDynamicReport});
  }

  saveSupplierResponse(orderId: string, itemCode: string, comment: string, reasonCode: string){
    const requestHeader = {};
    requestHeader['order_id'] = orderId;
    requestHeader['item_code'] = itemCode;
    requestHeader['comment'] = comment;
    requestHeader['reason_code'] = reasonCode;

    return this.dataService.postData(this.configurationManager.getApiUrl('apiVendorsUrl') + '/fillrate/comments/supplier',requestHeader, null);

  }

  saveRetailerResponse(orderId: string, itemCode: string, comment: string, reasonCode: string){
    const requestHeader = {};
    requestHeader['order_id'] = orderId;
    requestHeader['item_code'] = itemCode;
    requestHeader['comment'] = comment;
    requestHeader['reason_code'] = reasonCode;

    return this.dataService.postData(this.configurationManager.getApiUrl('apiVendorsUrl') + '/fillrate/comments/retailer',requestHeader, null);
  }

  getFillRateData(supplierCode: string,nomenclatureCode: string, nomenclatureLevel: string,dateFrom: Date, dateTo: Date, documentNo: string, articleCode: string): Observable<Array<IFillRateData>> {
    const requestHeaders = {};
    requestHeaders['supplier'] = supplierCode;
    requestHeaders['noma_code'] = nomenclatureCode;
    requestHeaders['noma_level'] = nomenclatureLevel;
    requestHeaders['datefrom'] = dateFrom;
    requestHeaders['dateuntil'] = dateTo;

    requestHeaders['documentNo'] =documentNo?documentNo:'';

    requestHeaders['article'] = articleCode?articleCode:'';
//    this.dataService.getReportData(this.configurationManager.getApiUrl('apiVendorsUrl') + `/fillrate?limit${this.limit}&offset=${this.offset}`,requestHeaders, ['supplier','noma_code','datefrom','dateuntil']).subscribe(

    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiVendorsUrl') + `/fillrate`,requestHeaders, ['supplier','noma_code','datefrom','dateuntil']).pipe(
      map(result=>{
        const data:Array<IFillRateData> = result.report.map(item=>this.mapFillRateDataFromService(item));
        return data;
      })
    );
/*

      (data)=>{
        if (data && data['report']) {
          const arr: Array<IFillRateData> = data['report'].map(item=>{
            const result = {
              isBlocked: item['block']==="1",
              retailerCode: item['retailer_code']?item['supplier_code']:'',
              retailerName: item['retailer_name']?item['supplier_name']:'',

              supplierCode: item['supplier_code'],
              supplierName: item['supplier_name'],

              nomaLevel1Code: item['noma_1_code'],
              nomaLevel2Code: item['noma_2_code'],
              nomaLevel3Code: item['noma_3_code'],
              nomaLevel4Code: item['noma_4_code'],
              nomaLevel5Code: item['noma_5_code'],
              nomaLevel6Code: '',

              nomaLevel1DisplayCode: item['noma_1_name'],
              nomaLevel2DisplayCode: item['noma_2_name'],
              nomaLevel3DisplayCode: item['noma_3_name'],
              nomaLevel4DisplayCode: item['noma_4_name'],
              nomaLevel5DisplayCode: item['noma_5_name'],
              nomaLevel6DisplayCode: '',

              itemCode: item['item_code'],
              itemName: item['item_name'],
              ean: item['ean'],

              flowCode: item['flow_code'],
              flowName: item['flow_name']?item['flow_name']:item['flow_code'],
              activityCode: item['activity'],
              activityName: item['activity_name']?item['activity_name']:item['activity'],
              pcb: item['pcb'],
              fullOrderCode: item['order_id'],
              orderCode: item['original_order_no'],
              orderedQuantity: item['order_value'],
              deliveredQuantity: item['delivery_value'],
              unDeliveredQuantity: item['undelivered_quantity'], //['undelivered_value'],
              fillRate: item['fill_rate'],
              orderDate: item['order_date'],//,//в формате YYYYMMDD
              expectedDeliveryDate: item['expected_date'],//item[''], //в формате YYYYMMDD
              receptionDate: item['fact_delivery_date'],//item[''],//в формате YYYYMMDD

              supplierResponseCode: item['supplier_reason_code'],
              supplierResponseName: '',//item['supplier_reason_code']?this.supplierResponseList.find(element => element.code === item['supplier_reason_code']).name: '',
              supplierResponseDescription: item['supplier_comment'],

              retailerResponseCode: item['retailer_reason_code'],
              retailerResponseName: '',// item['retailer_reason_code']?this.retailerResponseList.find(element => element.code === item['retailer_reason_code']).name: '',
              retailerResponseDescription: item['retailer_comment'],

              operation: item['operation'],
              week: (paramState.selectedDateFrom?moment(paramState.selectedDateFrom ,'YYYYMMDD').format('DD MMM YYYY'):'') + '-' + (paramState.selectedDateTo?moment(paramState.selectedDateTo ,'YYYYMMDD').format('DD MMM YYYY'):''),
              //moment(paramState.selectedDateFrom).format('DD.MM.YYYY') + '-' + moment(paramState.selectedDateTo).format('DD.MM.YYYY') , //item['week'],
              acquisitionPrice: item['acquisition_price']
            };
            result.supplierResponseName = item['supplier_reason_code']?
              this.supplierResponseList.find(element => element.code === item['supplier_reason_code'])?
                this.supplierResponseList.find(element => element.code === item['supplier_reason_code']).name:''
              : '';
            result.retailerResponseName = item['retailer_reason_code']?
              this.retailerResponseList.find(element => element.code === item['retailer_reason_code'])?
                this.retailerResponseList.find(element => element.code === item['retailer_reason_code']).name:''
              : '';
            return result;
          });

          if (!data['Next']) {
            this.isLoadingFull = true;
          }
          console.log(data['Next']);

          this.offset = this.offset + this.limit;

          this.updateTableData(arr);
          this.loadingInProgress = false;
        }
      })
    );*/
  }
  mapFillRateDataFromService(item): IFillRateData{
    const result: IFillRateData = {
      isBlocked: item['block']==="1",
      retailerCode: item['retailer_code']?item['supplier_code']:'',
      retailerName: item['retailer_name']?item['supplier_name']:'',

      supplierCode: item['supplier_code'],
      supplierName: item['supplier_name'],

      nomaLevel1Code: item['noma_1_code'],
      nomaLevel2Code: item['noma_2_code'],
      nomaLevel3Code: item['noma_3_code'],
      nomaLevel4Code: item['noma_4_code'],
      nomaLevel5Code: item['noma_5_code'],
      nomaLevel6Code: '',

      nomaLevel1DisplayCode: item['noma_1_name'],
      nomaLevel2DisplayCode: item['noma_2_name'],
      nomaLevel3DisplayCode: item['noma_3_name'],
      nomaLevel4DisplayCode: item['noma_4_name'],
      nomaLevel5DisplayCode: item['noma_5_name'],
      nomaLevel6DisplayCode: '',

      itemCode: item['item_code'],
      itemName: item['item_name'],
      ean: item['ean'],

      flowCode: item['flow_code'],
      flowName: item['flow_name']?item['flow_name']:item['flow_code'],
      activityCode: item['activity'],
      activityName: item['activity_name']?item['activity_name']:item['activity'],
      pcb: item['pcb'],
      fullOrderCode: item['order_id'],
      orderCode: item['original_order_no'],
      orderedQuantity: item['order_value'],
      deliveredQuantity: item['delivery_value'],
      unDeliveredQuantity: item['undelivered_quantity'], //['undelivered_value'],
      fillRate: item['fill_rate'],
      orderDate: item['order_date'],//,//в формате YYYYMMDD
      expectedDeliveryDate: item['expected_date'],//item[''], //в формате YYYYMMDD
      receptionDate: item['fact_delivery_date'],//item[''],//в формате YYYYMMDD

      supplierResponseCode: item['supplier_reason_code'],
      supplierResponseName: '',//item['supplier_reason_code']?this.supplierResponseList.find(element => element.code === item['supplier_reason_code']).name: '',
      supplierResponseDescription: item['supplier_comment'],

      retailerResponseCode: item['retailer_reason_code'],
      retailerResponseName: '',// item['retailer_reason_code']?this.retailerResponseList.find(element => element.code === item['retailer_reason_code']).name: '',
      retailerResponseDescription: item['retailer_comment'],

      operation: item['operation'],
      week: '',//(paramState.selectedDateFrom?moment(paramState.selectedDateFrom ,'YYYYMMDD').format('DD MMM YYYY'):'') + '-' + (paramState.selectedDateTo?moment(paramState.selectedDateTo ,'YYYYMMDD').format('DD MMM YYYY'):''),
      //moment(paramState.selectedDateFrom).format('DD.MM.YYYY') + '-' + moment(paramState.selectedDateTo).format('DD.MM.YYYY') , //item['week'],
      acquisitionPrice: item['acquisition_price']
    };
    // result.supplierResponseName = item['supplier_reason_code']?
    //   this.supplierResponseList.find(element => element.code === item['supplier_reason_code'])?
    //     this.supplierResponseList.find(element => element.code === item['supplier_reason_code']).name:''
    //   : '';
    // result.retailerResponseName = item['retailer_reason_code']?
    //   this.retailerResponseList.find(element => element.code === item['retailer_reason_code'])?
    //     this.retailerResponseList.find(element => element.code === item['retailer_reason_code']).name:''
    //   : '';
    return result;
  }


}
